/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/coins_1'
export default icon
